import { RequestHandler } from 'express';

import { saveRecorded } from '~/app/mockingMiddleware';

import ContentTypeService from '~/services/ContentTypeService';
import ModelMigrationService from '~/services/ModelMigrationService';
import { mapPayloadToMigrateOperations } from '~/transformations/mapPayloadToMigrateOperations';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';
import { MigrateOperations, MigrateRequest } from '~/services';

export const returnModels: RequestHandler = (req, res) => {
  const {
    id,
    service,
    operations,
  }: {
    id?: string;
    service?: ContentTypeService;
    operations?: MigrateOperations;
  } = res.locals;

  const modelIds =
    operations?.models?.map((m) => (typeof m === 'string' ? m : m.id)) || [];

  const response = service?.source.context.models.filter((m) =>
    id
      ? m.id.toLowerCase() === (id || '').toLowerCase()
      : (Array.isArray(operations?.models) &&
          (modelIds.includes(m.id) || modelIds.length === 0)) ||
        true
  );
  res.send(response);

  saveRecorded(req, res, {
    operation: 'returnModels',
    response,
  });
};

export const migrateModels: RequestHandler = async (req, res) => {
  try {
    const {
      payload,
      id,
      preview = true,
    }: {
      payload?: MigrateRequest;
      id?: string;
      preview?: boolean;
    } = res.locals;
    if (payload) {
      // Also check payload for ids
      const { migrate } = mapPayloadToMigrateOperations(payload);
      const modelIds = (id && [id]) || migrate.models;

      const migrationService = new ModelMigrationService(payload, preview);
      const response = await migrationService.MigrateModels(modelIds);

      if (response?.errors) {
        res.setHeader('expose-raw-errors', 'true');
        res.status(422).send(response);
        return;
      }

      res.send(response);

      saveRecorded(req, res, {
        operation: 'migrateModels',
        response,
      });
    }
  } catch (ex) {
    res.setHeader('expose-raw-errors', 'true');
    res.status(500).send({ error: mapAppErrorToObject(ex as any) });
  }
};

export const diffModels: RequestHandler = async (req, res) => {
  try {
    const { payload }: { payload?: MigrateRequest } = res.locals;
    const { id, preview } = res.locals;
    if (payload) {
      // Also check payload for ids
      const {
        components = [],
        contentTypes = [],
        models = [],
      } = mapPayloadToMigrateOperations(payload);

      const migrationService = new ModelMigrationService(payload, preview);

      // Get the ids from the id param or payload data
      const componentIds = id ? [id] : components || [];
      const contentTypeIds = id ? [id] : contentTypes || [];

      const response = await migrationService.Diff(
        models,
        contentTypeIds,
        componentIds
      );

      res.send(response);
      saveRecorded(req, res, {
        operation: 'diff',
        response,
      });
    }
  } catch (ex) {
    res.setHeader('expose-raw-errors', 'true');
    res.status(500).send({ error: mapAppErrorToObject(ex as any) });
  }
};
